<template>
    <div class="navbar">
        <h2>
            <i class="iconfont icon-baocunbuju"></i>
            &nbsp;{{shopname}} {{$t('a_LayoutPic')}}
        </h2>
        <a href="javascript:;" class="backlayout" @click="backHome">
                <i class="iconfont icon-back1"></i>
            </a>
    </div>
</template>
<script>
export default {
    props: ['shopname'],
    methods: {
        backHome() {
            this.$router.push('/layout');
        }
    }
}
</script>
<style lang="less">
.navbar .backlayout {
    position: absolute;
    left: 0;
    top: 0;
    width: 45px;
    min-width: 0px;
    background-color: #1c1d1e;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/layoutshop/components/navbar.vue